var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_pin_svg__Icon feather-map-pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "map_pin_svg__Path 18864",
    d: "M17.364 9.182C17.364 15.545 9.182 21 9.182 21C9.182 21 1 15.545 1 9.182C1 7.012 1.86203 4.93088 3.39645 3.39645C4.93088 1.86203 7.012 1 9.182 1C11.352 1 13.4331 1.86203 14.9675 3.39645C16.502 4.93088 17.364 7.012 17.364 9.182Z",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "map_pin_svg__Path 18865",
    d: "M11.91 9.18199C11.91 9.72129 11.7501 10.2485 11.4505 10.6969C11.1509 11.1454 10.725 11.4949 10.2268 11.7013C9.72857 11.9077 9.18031 11.9618 8.65135 11.8567C8.12239 11.7515 7.63649 11.4919 7.25507 11.1106C6.87365 10.7293 6.61385 10.2435 6.50852 9.71461C6.40318 9.18569 6.45704 8.63741 6.66329 8.1391C6.86954 7.64079 7.21891 7.21482 7.66723 6.91505C8.11555 6.61529 8.64269 6.45518 9.182 6.45499C9.54019 6.45486 9.89491 6.52529 10.2259 6.66228C10.5568 6.79927 10.8576 7.00011 11.1109 7.25335C11.3643 7.50659 11.5652 7.80726 11.7023 8.13818C11.8394 8.4691 11.91 8.82379 11.91 9.18199Z",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map_pin.3a99c5e38cc1ad9aa653137bb4cb89ac.svg";
export { ForwardRef as ReactComponent };